<div class="rush-profile" (click)="toggleDropdown()">
  <div class="avatar">
    <img *ngIf="profilePicture; else defaultProfile" [src]="profilePicture" />
    <ng-template #defaultProfile>
      <div class="profile-picture">
        <img src="/assets/rush/svg/default-profile.svg" />
      </div>
    </ng-template>
  </div>
  <div class="info">
    <div class="display-name" *ngIf="!shouldHide">{{ accountName || '' }}</div>
    <div class="coin-container">Credits: ₱ {{ chips || 0 | number: '0.0-2' }}</div>
  </div>

  <div
    *ngIf="isDropdownOpen"
    class="absolute right-0 z-40 mt-10 w-full rounded-lg bg-[#2F5521] shadow-lg"
  >
    <ul class="py-2">
      <li
        class="cursor-pointer px-4 py-2 hover:bg-green-100 hover:text-black"
        (click)="onTabSelected(dockTabs[1])"
      >
        Mechanics
      </li>
      <li
        class="cursor-pointer px-4 py-2 hover:bg-green-100 hover:text-black"
        (click)="onTabSelected(dockTabs[2])"
      >
        Auto Bet Settings
      </li>

      <li
        class="cursor-pointer px-4 py-2 hover:bg-green-100 hover:text-black"
        (click)="onTabSelected(dockTabs[3])"
      >
        Coins
      </li>
      <!-- <li
        class="cursor-pointer px-4 py-2 hover:bg-green-100 hover:text-black"
        (click)="onTabSelected(dockTabs[2])"
      >
        Auto Bet Settings
      </li> -->
      <li class="cursor-pointer px-4 py-2 hover:bg-green-100 hover:text-black" (click)="logout()">
        Logout
      </li>
    </ul>
  </div>
</div>
